import { AWS_S3_URL } from 'utils/constants'

export const CONTRACT_FILE_CLASSIFICATION_ID = '79ca2fef-1319-44d9-aa88-b01fb23b67bc'
export const IMG_CHECK_ICON = `${AWS_S3_URL}/img/check-icon.svg`
export const IMG_IFRAME_SHIELD = `${AWS_S3_URL}/img/Ilustraciones/secure-01.svg`
export const ONBOARDING_BACKEND_GENERAL_FILE_CLASSIFICATION_ID = 'd1e47902-5a69-411d-8b9a-9d4d29e05924'
export const ONBOARDING_BACKEND_PDF_FILE_TYPE_ID = 'dce83ee9-5910-4dd3-9af3-3076418158df'
export const SUCCESS_MESSAGE = 'Contrato Conekta firmado con éxito'
export const TERMS_AND_CONDITIONS_URL = 'https://www.conekta.com/legal/tos'
